/** Shared scan-status polling constants (single source of truth). */

/**
 * Step Functions execution statuses that end a scan. Once a poll returns one of
 * these, polling stops and onComplete fires. Shared by ScanProgress,
 * DiscoveryScanProgress, and TeamScanProgress so the terminal set can't drift.
 */
export const TERMINAL_STATES = new Set(['SUCCEEDED', 'FAILED', 'TIMED_OUT', 'ABORTED']);

/** Poll cadence for the single-execution scan-progress views (5s). */
export const POLL_INTERVAL_MS = 5_000;
